/**
 * subjectFeesApi.js
 * -----------------
 * API client for Subjectwise Fees Master using createMasterApiClient.
 * Connects directly to FastAPI backend /subject-fees/ endpoints.
 */
import { createMasterApiClient } from '../../common/masterApiFactory';

export const subjectFeesClient = createMasterApiClient('subject-fees');

export const listSubjectFees = (params) => subjectFeesClient.list(params);
export const getSubjectFeesDetail = (id) => subjectFeesClient.getById(id);
export const createSubjectFees = (data) => subjectFeesClient.create(data);
export const updateSubjectFees = (id, data) => subjectFeesClient.update(id, data);
export const archiveSubjectFees = (id) => subjectFeesClient.archive(id);
export const deleteSubjectFees = (id) => subjectFeesClient.remove(id);
